<ag-charts-angular *ngIf="options" [ngStyle]="{'width': '100%', 'height': '85vh'}" [options]="options">
</ag-charts-angular>